module.exports = __webpack_public_path__ + "img/IMG_9401.dab9db4c.jpg";